/* eslint-disable @typescript-eslint/explicit-function-return-type */
import routeNames from '@/router/routeNames'

import type { StrictRouteConfig } from 'types/router'

const ReportingPage = () => import('@/pages/Reporting/ReportingPage.vue')

const routeConfig: StrictRouteConfig[] = [
  {
    path: '/reporting',
    component: ReportingPage,
    name: routeNames.REPORTING,
    meta: { requiresAuth: true, title: 'Reporting' },
  },
]

export default routeConfig
